export default __webpack_public_path__ + "static/media/appIconMobile.25134282.svg";